import './AccountsTableByType.scss';

import { array, string, number, bool } from 'prop-types';
import React, { Fragment } from 'react';

import AccountRow from 'components/shared/AccountRow/AccountRow';
import Checkbox from 'components/shared/Checkbox/Checkbox';
import { ReactComponent as LockIcon } from 'assets/icons/lock-2.svg';
import { groupAccountsByType } from 'state/linkedBankAccounts/LinkedBankAccountsSelectors';

import { connect } from 'react-redux';
import { getAccountsById } from 'state/account/AccountSelectors';

class AccountsTableByType extends React.Component {
  state = {
    hideAccounts: true
  };

  showAllAccounts = () => {
    this.setState({
      hideAccounts: false
    });
  };

  render() {
    const {
      accounts,
      bankRestrictions,
      accountsById,
      leftColTitle,
      rightColTitle,
      initialVisible,
      includeCheckbox,
      handleCheckUpdate
    } = this.props;

    const accountsWithData = accounts.map((b) => {
      const identifier =
        b.accountDescriptor && b.accountDescriptor.accountId
          ? b.accountDescriptor.accountId
          : '';
      const restrictions = bankRestrictions
        ? bankRestrictions.filter(
            (r) =>
              r &&
              r.restrictedAccounts &&
              r.restrictedAccounts.some((acct) => acct.accountId == identifier)
          )
        : [];
      return {
        ...b.accountDescriptor,
        restrictions,
        pendingUpdate: b.pendingUpdate,
        ...accountsById[identifier]
      };
    });

    const { hideAccounts } = this.state;

    const displayableAccounts = hideAccounts
      ? accountsWithData.slice(0, initialVisible)
      : accountsWithData;
    const displayableAccountsByType = groupAccountsByType(displayableAccounts);
    const hiddenAccounts = accounts.length - displayableAccounts.length;

    return (
      <Fragment>
        <div className="account-table-container">
          <div className="account-table-titles">
            <div className="title-left">{leftColTitle}</div>
            <div className="title-right">{rightColTitle}</div>
          </div>
          {Object.keys(displayableAccountsByType).map((accountsType, i) => (
            <Fragment key={i}>
              <div className="account-type-container">
                <div className="account-type-banner">
                  <div className="account-type-text">{accountsType}</div>
                </div>
              </div>
              {displayableAccountsByType[accountsType] &&
                displayableAccountsByType[accountsType].map((account, i) => {
                  return includeCheckbox ? (
                    <div className="account-checkbox-container" key={i}>
                      {!account.locked && account.restrictions.length == 0 && (
                        <div className="account-checkbox">
                          <Checkbox
                            checked={account.checked}
                            onChange={() => handleCheckUpdate(account)}
                            name={`${account.accountId}-checkbox`}
                          />
                        </div>
                      )}
                      {account.locked ||
                        (account.restrictions.length > 0 && <LockIcon />)}
                      <AccountRow
                        account={account}
                        includePending={account.pendingUpdate}
                        key={i}
                      />
                    </div>
                  ) : (
                    <AccountRow
                      account={account}
                      includePending={account.pendingUpdate}
                      key={i}
                    />
                  );
                })}
            </Fragment>
          ))}
        </div>
        {hiddenAccounts > 0 && (
          <div className="show-more" onClick={() => this.showAllAccounts()}>
            Show More Investments ({hiddenAccounts})
          </div>
        )}
      </Fragment>
    );
  }
}

AccountsTableByType.propTypes = {
  accounts: array,
  leftColTitle: string,
  rightColTitle: string,
  initialVisible: number,
  includeCheckbox: bool
};

AccountsTableByType.defaultProps = {
  accounts: [],
  leftColTitle: '',
  rightColTitle: '',
  initialVisible: 3,
  includeCheckbox: false
};

const mapStateToProps = (state) => ({
  accountsById: getAccountsById(state)
});

export default connect(mapStateToProps)(AccountsTableByType);
